import _taggedTemplateLiteral from "/codebuild/output/src997666004/src/github.com/EverlyWell/www/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 100%;\n  object-fit: contain;\n  max-height: 245px;\n  max-width: 768px;\n  flex: 0 0 auto;\n  ", " {\n    max-height: 349px;\n  }\n\n  ", " {\n    max-height: 513px;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  min-height: 245px;\n  overflow: hidden;\n  position: relative;\n  justify-content: center;\n  display: flex;\n  height: 100%;\n  width: 100%;\n  ", " {\n    min-height: 349px;\n  }\n  ", " {\n    min-height: 513px;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  flex-wrap: wrap;\n  flex-direction: column;\n  display: flex;\n  flex: 0 0 100%;\n  align-items: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from "styled-components";
import { animated } from "react-spring";
import { mediaQueries } from "../../../shared/constants";
var Slide = styled.div(_templateObject()),
    imageContainerStyles = css(_templateObject2(), mediaQueries.forTabletVerticalUp, mediaQueries.forDesktopUp),
    ImageContainer = styled.div(_templateObject3(), imageContainerStyles),
    ImageComponentContainer = styled(animated.div)(_templateObject4(), imageContainerStyles),
    Image = styled(animated.img)(_templateObject5(), mediaQueries.forTabletVerticalUp, mediaQueries.forDesktopUp);
export { Slide, Image, ImageContainer, ImageComponentContainer };